<template lang="pug">
  .tko-tariff
    .body.body-table
      .table-choose-panel
        .toolbar.toolbar_no-padding.toolbar_margin-bottom
          .toolbar__line.line(style="justify-content: space-between")
            .parameters
              .semibold {{tariffsTitle}}
            .actions-panel.view-panel
              e-button-delete(@click="deleteLastTariffCol").actions-panel__button.btn-delete.reset-btn.button.button_delete.button_small.button_icon.e-button-delete
              e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="showModalSmallTarif = !showModalSmallTarif" label="Добавить" )
              e-button-delete.actions-panel__button.actions-panel__button_text.button.reset-btn(
                v-if="hasCalculateTariff"
                @click="calculateTariff"
                label="Рассчитать"
              )
        div#tarif(style='margin-bottom:20px')
          .e-table.table.table_tariff.table_static-last-child
            div.e-table__body-wrapper.table__body-wrapper
              .e-table__body.table__body
                div.e-table__row.table__row.table__row_justify-start
                  .e-table__col.table__col.e-table__head.table__head.table__col_double-width Наименование
                  template(v-for="item in Object.values(tkoOperatorTariffsByTariffId)[0]")
                    .e-table__col.table__col.table__col_double-width(:key="item.id" ) {{item.year}}/{{item.part === 1 ? 'II' : 'I'}}
                .e-table__row.table__row.table__row_justify-start(v-for="(tkoOperatorTariff, index) in tkoOperatorTariffsByTariffId")
                  .e-table__col.table__col.table__col_double-width {{TARIFFS[index].label}}
                  .e-table__col.table__col.table__col_double-width(v-for="(item) in tkoOperatorTariff" v-if="TARIFFS[index]")
                    input.input(
                      type="text"
                      v-model="item.value"
                      @change="changeTariff"
                    )
                .e-table__row.table__row.table__row_justify-start(v-if="Object.keys(tkoOperatorTariffsByTariffId).length < 1"
                  v-for="(TARIFF) in TARIFFS")
                  .e-table__col.table__col.table__col_double-width(v-if="TARIFF") {{TARIFF.label}}
                  .e-table__col.table__col.table__col_double-width

        div(v-if="!hideCalc").actions-panel
          button(@click="downloadTariffCalculationsFile").actions-panel__button.btn-blue.button.reset-btn Расчёт тарифа объекта методом инвестированного капитала
    e-modal(
      v-if="showModalSmallTarif"
      @close="showModalSmallTarif = false"
      @confirm="addNewTariffRow()"
      title="Добавление новых столбцов"
    )
      slot
        .col
          .body
            .col-block
              label.label.semibold Добавить за период
              .half-block#tarifModal(style='height:auto')
                div
                  label.label.semibold От
                  e-select(
                    :model="tariffPeriods"
                    name="from"
                    tabView="tab6"
                    :options="getTariffFromPeriod")
                div
                  label.label.semibold До
                  e-select(
                    :model="tariffPeriods"
                    name="to"
                    tabView="tab6"
                    :options="getTariffToPeriod"
                  )
              span.invalid.error {{addNewTariffRowError}}
    e-modal(
      v-if="showModalTariffsError"
      @close="showModalTariffsError = false"
      title="Ошибки при расчетах"
      :showFooter="false"
    )
      slot
        div.tko-tariff__errors
          span.tko-tariff__errors-text Невозможно рассчитать некоторые значения, поскольку у вас не заполнены поля для их расчета:
          div.tko-tariff__error(v-for="error in tariffsErrors") Поле "необходимая валовая выручка регионального оператора в году (руб.)" за {{error.year}}
          button.button.button_color.button_no-border.text-left.no-padding.button_hover-link.height-auto.tko-tariff__error(@click="linkToOperator") Поле "Образовано, тонн" на странице регионального оператора "во вкладке "Отходы"
</template>

<script>
import saveFile from '@/utils/saveFile'
import { calculation, tko } from '@/api/api-endpoints'
import { GROSS_PROCEEDS_ID, COMMON_TARIFF_ID } from '@/config/config'
import url from '@/utils/url'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'

export default {
  name: 'tko-tariff',
  mixins: [hasMixin, textMixin],
  props: {
    hideCalc: {
      type: Boolean,
      default: true,
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    operatorId: {
      type: [Number, String],
      default: null,
    },
    tkoOperatorTariffs: {
      type: Array,
      default: () => [],
    },
    TARIFFS: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    showModalSmallTarif: false,
    showModalTariffsError: false,
    tariffPeriods: {
      from: '',
      to: '',
    },
    addNewTariffRowError: null,
    tkoOperatorTariffsByYearPart: [],
    tariffsErrors: [],
  }),
  computed: {
    tkoOperatorTariffsByTariffId() {
      const tkoOperatorTariffsByYearPart = this.tkoOperatorTariffsByYearPart
      let tariffsByTariffId = {}
      for (let yearPartKey in tkoOperatorTariffsByYearPart) {
        let tmp = tkoOperatorTariffsByYearPart[yearPartKey]
        for (let key in tmp) {
          if (!tariffsByTariffId[key]) {
            tariffsByTariffId[key] = {}
          }
          tariffsByTariffId[key][yearPartKey] = tmp[key]
        }
      }
      return tariffsByTariffId
    },
    getLastBiggestYearPart() {
      let last = '2010,0'
      if (this.tkoOperatorTariffsByYearPart) {
        for (let keyPart in this.tkoOperatorTariffsByYearPart) {
          last = keyPart
        }
      }
      return last
    },
    getTariffFromPeriod() {
      return this.generateYearsParts(this.getLastBiggestYearPart, '2050,2')
    },
    getTariffToPeriod() {
      return this.generateYearsParts(this.tariffPeriods.from, '2050,2', true)
    },
    COMMON_TARIFF_ID() {
      return COMMON_TARIFF_ID
    },
  },
  watch: {
    tkoOperatorTariffs: {
      handler: 'createTkoOperatorTariffsByYearPart',
      immediate: true,
    },
  },
  methods: {
    async getTariffs() {
      if (this.operatorId) {
        const tkoOperator = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: tko.operator(this.operatorId),
          })
        ).data
        this.tkoOperatorFields = Object.assign({}, tkoOperator)
        return tkoOperator.tkoOperatorTariffs
      }
    },
    async createTkoOperatorTariffsByYearPart() {
      let tariffsByYearPart = {}
      let tkoOperatorTariffs
      if (this.operatorId) {
        tkoOperatorTariffs = await this.getTariffs()
      } else {
        tkoOperatorTariffs = this.tkoOperatorTariffs.slice()
      }
      // sort by year, part
      tkoOperatorTariffs.sort((a, b) => {
        let sumA = `${a.year}${a.part}`
        let sumB = `${b.year}${b.part}`
        if (+sumA < +sumB) {
          return -1
        } else if (+sumA > +sumB) {
          return 1
        }
        return 0
      })
      // generate by year part
      tkoOperatorTariffs.forEach((v) => {
        let id = v.year + ',' + v.part
        if (!tariffsByYearPart[id]) {
          tariffsByYearPart[id] = {}
        }
        tariffsByYearPart[id][v.tko_tariff_id] = v
      })
      // create empty models if needed
      for (let key in tariffsByYearPart) {
        let tariffs = tariffsByYearPart[key]

        let year = tariffs[Object.keys(tariffs)[0]].year
        let part = tariffs[Object.keys(tariffs)[0]].part
        for (let TARIFF_KEY in this.TARIFFS) {
          let v = this.TARIFFS[TARIFF_KEY]
          if (!tariffs[v.id]) {
            tariffs[v.id] = {
              value: 0,
              tko_tariff_id: v.id,
              year: year,
              part: part,
            }
          }
        }
      }
      this.tkoOperatorTariffsByYearPart = Object.assign({}, tariffsByYearPart)
    },
    deleteLastTariffCol() {
      this.$e.confirmBox('', 'Удалить последнюю колонку?', 'Да').then(() => {
        const keys = Object.keys(this.tkoOperatorTariffsByYearPart)
        const last = keys[keys.length - 1]
        delete this.tkoOperatorTariffsByYearPart[last]

        this.tkoOperatorTariffsByYearPart = Object.assign(
          {},
          this.tkoOperatorTariffsByYearPart
        )
      })
    },
    downloadTariffCalculationsFile() {
      if (!this.entityId) {
        return
      }
      this.$bar.start()
      this.$store
        .dispatch('downloadFile', {
          endpoint: this.getCalcDownloadEndpoint(),
        })
        .then((r) => {
          this.$bar.finish()
          saveFile({
            blob: r.request.response,
            headers: r.headers,
          })
        })
        .catch((e) => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
    },
    parseYear(from, to) {
      return {
        fromYear: from.split(',')[0],
        fromPart: +from.split(',')[1],
        toYear: +to.split(',')[0],
        toPart: +to.split(',')[1],
      }
    },
    generateYearsParts(from, to, putCurrent) {
      let { fromYear, fromPart, toYear } = this.parseYear(from, to)

      if (!fromYear) {
        return []
      }

      let tmp = []
      if (putCurrent) {
        if (fromPart === 1) {
          tmp.push({
            id: `${fromYear},${fromPart}`,
            name: `${fromYear}, 2 полугодие`,
          })
        } else {
          tmp.push({
            id: `${fromYear},${fromPart}`,
            name: `${fromYear}, 1 полугодие`,
          })
        }
      }

      let skipFirst = false
      if (fromPart === 1) {
        fromYear = +fromYear + 1
      } else {
        skipFirst = true
      }

      for (let i = fromYear; i < toYear; i++) {
        if (skipFirst === false) {
          tmp.push({ id: `${i},0`, name: `${i}, 1 полугодие` })
        } else {
          skipFirst = false
        }
        tmp.push({ id: `${i},1`, name: `${i}, 2 полугодие` })
      }

      return tmp
    },
    addNewTariffRow() {
      this.addNewTariffRowError = null
      let { fromYear, fromPart, toYear, toPart } = this.parseYear(
        this.tariffPeriods.from,
        this.tariffPeriods.to
      )

      if (
        !toYear ||
        !fromYear ||
        toYear < fromYear ||
        (toYear === fromYear && toPart <= fromPart)
      ) {
        this.addNewTariffRowError = 'Укажите первый и второй кварталы'
        return false
      }

      let len = (toYear - fromYear) * 2 + 1
      let year = fromYear
      let start = 1
      if (fromPart === 1) {
        start = 2
      }
      if (toPart === 1) {
        len = len + 1
      }
      for (let i = start; i <= len; i++) {
        let part = 1
        if (i & 1) {
          part = 0
        }

        let id = year + ',' + part
        if (!this.tkoOperatorTariffsByYearPart[id]) {
          this.tkoOperatorTariffsByYearPart[id] = {}
        }
        for (let TARIFF_KEY in this.TARIFFS) {
          let v = this.TARIFFS[TARIFF_KEY]
          if (!this.tkoOperatorTariffsByYearPart[id][v.id]) {
            this.tkoOperatorTariffsByYearPart[id][v.id] = {
              value: 0,
              tko_tariff_id: v.id,
              year: year,
              part: part,
            }
          }
        }

        if (part === 1) {
          year++
        }
      }

      this.tkoOperatorTariffsByYearPart = Object.assign(
        {},
        this.tkoOperatorTariffsByYearPart
      )

      this.tariffPeriods.from = ''
      this.tariffPeriods.to = ''
      this.showModalSmallTarif = false
      this.changeTariff()
    },
    changeTariff() {
      const tariffs = []
      Object.values(this.tkoOperatorTariffsByYearPart).forEach((item) => {
        Object.values(item).forEach((v) => {
          tariffs.push(v)
        })
      })
      this.$emit('updateTariff', {
        tariffs,
      })
    },
    getTariffsArr() {
      const tkoOperatorTariffsByYearPart = this.tkoOperatorTariffsByYearPart

      let tmp = []
      for (let yearPart in tkoOperatorTariffsByYearPart) {
        let v = tkoOperatorTariffsByYearPart[yearPart]
        for (let tariffId in v) {
          tmp.push(tkoOperatorTariffsByYearPart[yearPart][tariffId])
        }
      }
      return tmp
    },
    getCalcDownloadEndpoint() {
      return calculation.indexMethodTariffTko(this.entityId)
    },
    async calculateTariff() {
      const entries = this.tkoOperatorTariffsByTariffId[GROSS_PROCEEDS_ID]
      const years = {}
      for (const [key, value] of Object.entries(entries)) {
        const year = key.split(',')[0]
        if (years[year]) {
          years[year] += Number(value.value)
        } else {
          years[year] = Number(value.value)
        }
      }
      const response = (
        await this.$store.dispatch('createModel', {
          url: tko.regionalTariff(
            this.operatorId ? this.operatorId : this.$route.params.id
          ),
          data: {
            gross_proceeds: years,
          },
        })
      ).data
      this.tariffsErrors = []
      for (const [key, value] of Object.entries(response)) {
        if (value === 0) {
          this.tariffsErrors.push({ year: key })
        }
      }

      if (this.tariffsErrors.length > 0) {
        this.showModalTariffsError = true
      } else {
        for (const [key] of Object.entries(this.tkoOperatorTariffsByYearPart)) {
          const year = key.split(',')[0]
          if (response[year]) {
            this.tkoOperatorTariffsByYearPart[key][6].value = (
              response[year] / 2
            ).toFixed(2)
          }
        }
      }
      this.changeTariff()
    },
    linkToOperator() {
      const params = {}
      if (this.operatorId) {
        params.id = this.operatorId
      }
      this.$router.push({
        name: 'registry.regionalOperators.update',
        params,
        query: {
          tabView: 'tab8',
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.half-block {
  display: flex;
  gap: 15px;
}
</style>
